var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('span',[_vm._v("Loading target...")]):_c('span',[_c('TargetCircles',{attrs:{"target":_vm.getTarget}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }